import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { TableCellData } from '../../../../../../../osp-ui/components/data/table/contract/table-cell-data.contract';
import { TableCellBase } from '../../../../../../../osp-ui/components/data/table/directives/table-cell-base.directive';
import { TABLE_CELL_DATA } from '../../../../../../../osp-ui/components/data/table/table.constant';
import { LocationType } from '../../../../../../../shared/enums/location-type.enum';
import { StockType } from '../../../../../../disposition/stocks/enums/stock-type.enum';
import { StockTypeResolverService } from '../../../../../../disposition/stocks/services/stock-type-resolver.service';
import { ProjectType } from '../../../../../enums/project-type.enum';
import { ProjectTypeResolverService } from '../../../../../services/project-type-resolver.service';
import { ActiveLocation, ActiveLocationCategory } from '../../../../contract/active-location.contract';

@Component({
  selector: 'osp-active-location-category-cell',
  standalone: true,
  templateUrl: './active-location-category-cell.component.html',
  styleUrl: './active-location-category-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveLocationCategoryCellComponent extends TableCellBase<ActiveLocationCategory> implements OnInit {
  protected icon = '';
  protected label = '';

  constructor(
    @Inject(TABLE_CELL_DATA) data: TableCellData,
    private readonly stockTypeResolverService: StockTypeResolverService,
    private readonly projectTypeResolverService: ProjectTypeResolverService,
  ) {
    super(data);
  }

  ngOnInit(): void {
    const location = this.row as ActiveLocation;

    if (location.type === LocationType.STOCK) {
      const stockType = location.category as StockType;
      this.icon = this.stockTypeResolverService.resolveIcon(stockType);
      this.label = this.stockTypeResolverService.resolveName(stockType);
      return;
    }

    this.label = this.projectTypeResolverService.resolveName(location.category as ProjectType);
  }
}
